import { useQuery } from 'react-query';
import {
  fetchAnalyticsData,
  fetchPerformanceMetrics,
  fetchOptimizationStrategies,
} from '../api/analytics.ts';

export const useAnalytics = (timeRange: string = '7d') => {
  const {
    data: analyticsData,
    isLoading: analyticsLoading,
    error: analyticsError,
  } = useQuery(['analytics', timeRange], () => fetchAnalyticsData());

  const {
    data: performanceMetrics,
    isLoading: metricsLoading,
  } = useQuery(['performanceMetrics', timeRange], () => fetchPerformanceMetrics(timeRange));

  const {
    data: strategies,
    isLoading: strategiesLoading,
  } = useQuery('optimizationStrategies', fetchOptimizationStrategies);

  return {
    performanceMetrics: performanceMetrics || analyticsData?.performanceMetrics,
    strategies: strategies || analyticsData?.strategies,
    isLoading: analyticsLoading || metricsLoading || strategiesLoading,
    error: analyticsError,
  };
}; 